<div class="buttons">
	<!--Back-->
	<button #navigationButton 
		(click)="back()" 
		class="button button_main btn-with-effect" 
		*ngIf="!isBackButtonHidden"
		[ngClass] = "{
			end_of_note_flow: isEndOfNoteFlow,
			'two_buttons_showing' : twoButtonsShowing
		}">
			Back
	</button>

	<!--Continue/Submit-->
	<button 
		#navigationButton
		(click)="continue()"
		class="button button_main btn-with-effect"
		[disabled]="isNextButtonDisabled"
		[ngClass]="{ 
			'start_of_note_flow': isStartOfNoteFlow,
			'end_of_note_flow': isEndOfNoteFlow,
			'two_buttons_showing' : twoButtonsShowing,
			'button_secondary': isSkipDisplayed
		}">
			{{ nextButtonText }}
	</button>
</div>